import { AccountStatuses } from 'mmfintech-backend-api'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'

// Closed accounts are deactivated, not deleted — they stay visible in the admin but leave the portal's lists
export function isOpenAccount({ accountStatus }: AccountBalanceResponse) {
  return accountStatus !== AccountStatuses.INACTIVE && accountStatus !== AccountStatuses.REMOVED
}
